import React, { useCallback, useEffect, useRef, useState } from "react";
import { Rive } from "@rive-app/canvas";
import {
  AnimationStyled,
  AnimationStyledMobile,
  TitleWrapper,
  ContainerWrapper,
} from "view/Home/Animation/AnimationStyled";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import CustomText from "components/Atoms/CustomText/CustomText";

const DSUAnimation = () => {
  const canvasRef = useRef(null);
  const canvasRefTablet = useRef(null);
  const canvasRefMobile = useRef(null);
  const riveRef = useRef(null);
  const riveRefTablet = useRef(null);
  const riveRefMobile = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const riveInstance = new Rive({
      src: "/dsuAnimation.riv",
      canvas: canvasRef.current,
      autoplay: true,
      stateMachines: "State Machine 1",
      onLoadError: (error) => {
        console.error('Error loading desktop animation:', error);
      },
      onLoad: () => {
        //console.log('Animation loaded');
        riveRef.current = riveInstance;

        // Get all inputs and log them
        const inputs = riveInstance.stateMachineInputs("State Machine 1");
        //console.log('Available Inputs:', inputs.map(input => input.name));

        // // Set default value if input exists
        const Scrollinpt = inputs.find((input) => input.name === "Scrollinpt");
        if (Scrollinpt) {
          Scrollinpt.value = 0;
        }
      },
    });
    const riveInstanceTablet = new Rive({
      src: "/dsuAnimation.riv",
      canvas: canvasRefTablet.current,
      autoplay: true,
      stateMachines: "State Machine 1",
      onLoadError: (error) => {
        console.error('Error loading tablet animation:', error);
      },
      onLoad: () => {
        //console.log('Animation loaded');
        riveRefTablet.current = riveInstanceTablet;

        // Get all inputs and log them
        const inputs = riveInstanceTablet.stateMachineInputs("State Machine 1");
        //console.log('Available Inputs:', inputs.map(input => input.name));

        // // Set default value if input exists
        const Scrollinpt = inputs.find((input) => input.name === "Scrollinpt");
        if (Scrollinpt) {
          Scrollinpt.value = 0;
        }
      },
    });

    const riveInstanceMobile = new Rive({
      src: "/dsuAnimation.riv",
      canvas: canvasRefMobile.current,
      autoplay: true,
      stateMachines: "State Machine 1",
      onLoadError: (error) => {
        console.error('Error loading mobile animation:', error);
      },
      onLoad: () => {
        //console.log('Animation loaded');
        riveRefMobile.current = riveInstanceMobile;

        // Get all inputs and log them
        const inputs = riveInstanceMobile.stateMachineInputs("State Machine 1");
        //console.log('Available Inputs:', inputs.map(input => input.name));

        // // Set default value if input exists
        const Scrollinpt = inputs.find((input) => input.name === "Scrollinpt");
        if (Scrollinpt) {
          Scrollinpt.value = 0;
        }
      },
    });

    return () => {
      riveInstance.cleanup();
      riveInstanceTablet.cleanup();
      riveInstanceMobile.cleanup();
    };
  }, []);
  const handleScroll = useCallback(() => {
    // console.log("isInView", isInView);
    if (!isInView) return; // Only update if animation is visible

    const scrollY = window.scrollY;
    const maxScroll = document.body.scrollHeight - window.innerHeight;

    // Map scroll position to input range (5 to 140)
    const mappedValue = Math.min(140, Math.max(5, (scrollY / maxScroll) * 140));

    // Update Rive input
    const scrollInput = riveRef.current
      ?.stateMachineInputs("State Machine 1")
      ?.find((input) => input.name === "Scrollinpt");
    if (scrollInput) {
      scrollInput.value = mappedValue;
      console.log(`Updated Scrollinpt to: ${mappedValue}`);
    }
  }, [isInView]);
  // Handle Scroll Input Update when visible
  useEffect(() => {
    // console.log("isInView assoc", isInView);
    if (isInView) {
      //window.addEventListener('wheel',(e)=> e.preventDefault(), { passive: false });
      //document.body.style.overflow = 'hidden';
      console.log("scrollY", window.scrollY);
      document.addEventListener("scroll", handleScroll);
      const scrollInput = riveRef.current
        ?.stateMachineInputs("State Machine 1")
        ?.find((input) => input.name === "Scrollinpt");
      const scrollInput2 = riveRefTablet.current
        ?.stateMachineInputs("State Machine 1")
        ?.find((input) => input.name === "Scrollinpt");
      const scrollInput3 = riveRefMobile.current
        ?.stateMachineInputs("State Machine 1")
        ?.find((input) => input.name === "Scrollinpt");

      if (scrollInput) {
        scrollInput.value = 140;
      }
      if (scrollInput2) {
        scrollInput2.value = 140;
      }
      if (scrollInput3) {
        scrollInput3.value = 140;
      }
    } else {
      window.removeEventListener("scroll", handleScroll);
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isInView, handleScroll]);

  // Detect when canvas is in viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      { threshold: 0.2 }
    );

    if (canvasRef.current) {
      observer.observe(canvasRef.current);
    }

    if (canvasRefTablet.current) {
      observer.observe(canvasRefTablet.current);
    }

    if (canvasRefMobile.current) {
      observer.observe(canvasRefMobile.current);
    }

    return () => {
      if (canvasRef.current) observer.unobserve(canvasRef.current);
      if (canvasRefTablet.current) observer.unobserve(canvasRefTablet.current);
      if (canvasRefMobile.current) observer.unobserve(canvasRefMobile.current);
    };
  }, []);

  return (
    <ContainerWrapper>
      <TitleWrapper>
        <CustomText
          text={
            "Harta sistemului integrat pentru situații de urgență din România"
          }
          type={TextType.H2}
          color={COLORS.VividAuburn}
        />
      </TitleWrapper>
      <AnimationStyled>
        {/*<canvas ref={canvasRef} width={1920} height={900}  />*/}
        <canvas
          className={"canvas-desktop"}
          ref={canvasRef}
          width={1280}
          height={600}
        />
        <canvas
          className={"canvas-tablet"}
          ref={canvasRefTablet}
          width={640}
          height={300}
        />
        <canvas
          className={"canvas-mobile"}
          ref={canvasRefMobile}
          width={320}
          height={150}
        />
      </AnimationStyled>
    </ContainerWrapper>
  );
};

export default DSUAnimation;
